const SvgStartIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 17" {...props}>
    <path
      fill="currentColor"
      d="M4.63 3.651c0-1.12 1.27-1.767 2.176-1.108l6.336 4.605a1.37 1.37 0 0 1 0 2.217l-6.336 4.606c-.906.658-2.177.011-2.177-1.109z"
    />
  </svg>
);

export default SvgStartIcon;
